export default __webpack_public_path__ + "static/media/add.c478f12c.svg";